import React, { useState } from "react";
import styles from "./Projects.module.css";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { motion } from "framer-motion";
import Pricing from "../Pricings/pricing";
import { FaBullseye, FaPhoneAlt, FaUniversity, FaUsers } from "react-icons/fa";
import ContactUs from "../contact/ContactUs";
import psshealth from "../../asset/psshealthimg.jpg";

const Projects = () => {
  const [filter, setFilter] = useState("all");

  const projects = [
    {
      id: 3,
      title: "Customer Support Automation",
      category: "voice",
      description:
        "Automated customer support system with ticket routing and resolution.",
      status: "completed",
      date: "2023-11-20",
      image:
        "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      tech: ["Node.js", "MongoDB", "Twilio", "Express"],
      link: "/projects/support-automation",
    },

    {
      id: 4,
      title: "Educational Chatbot Platform",
      category: "chatbot",
      description: "AI tutor platform for personalized learning experiences.",
      status: "planning",
      date: "2024-03-15",
      image:
        "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      tech: ["React", "Python", "OpenAI", "MongoDB"],
      link: "/projects/education-chatbot",
    },
    {
      id: 5,
      title: "SEOMan - AI Content Optimization Platform",
      category: "ai",
      description:
        "AI-powered SEO content creation system designed to generate high-ranking, keyword-optimized articles at scale.",
      status: "in-progress",
      date: "2024-04-05",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      tech: ["Python", "OpenAI", "Next.js", "PostgreSQL"],
      link: "/projects/seoman",
    },
    {
      id: 6,
      title: "AttendancePro - AI Face Recognition System",
      category: "ai",
      description:
        "Intelligent face detection system automating attendance tracking with real-time updates, analytics, and secure data storage.",
      status: "completed",
      date: "2024-02-18",
      image:
        "https://images.unsplash.com/photo-1526378722484-bd91ca387e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      tech: ["Python", "OpenCV", "TensorFlow", "React"],
      link: "/projects/attendancepro",
    },
    {
      id: 7,
      title: "PSS Healthcare - Smart Healthcare Platform",
      category: "voice",
      description:
        "Comprehensive healthcare management platform with patient tracking, doctor-patient sync, analytics, and secure cross-platform access.",
      status: "in-progress",
      date: "2024-03-22",
      image:
        "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      tech: ["React", "Node.js", "MongoDB", "AWS"],
      link: "/projects/pss-healthcare",
    },
    {
      id: 8,
      title: "Clinical Agentic AI",
      category: "voice",
      description:
        "End-to-end AI-powered healthcare assistant managing triage, voice-to-medical-note transcription, and automated prescription drafting.",
      status: "planning",
      date: "2024-04-12",
      image: psshealth,
      tech: ["Python", "LLMs", "FastAPI", "Whisper API"],
      link: "/projects/clinical-agentic-ai",
    },
    {
      id: 9,
      title: "CRO Tool - AI Document Intelligence Platform",
      category: "ai",
      description:
        "AI-powered document intelligence platform enabling smart document extraction, multi-document management, AI-driven SOW generation, and automated document validation.",
      status: "planning",
      date: "2024-04-20",
      image:
        "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      tech: ["Python", "FastAPI", "OpenAI", "OCR", "PostgreSQL"],
      link: "/projects/cro-tool",
    },
    {
      id: 10,
      title: "Summary AI - Voice Productivity App",
      category: "voice",
      description:
        "Voice-powered AI app that converts speech into structured summaries, meeting minutes, emails, action items, and shareable content instantly.",
      status: "completed",
      date: "2024-04-25",
      image:
        "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      tech: [
        "React Native (Expo)",
        "TypeScript",
        "Zustand",
        "OpenAI",
        "Expo AV",
        "Expo Router",
      ],
      link: "/projects/summary-ai",
    },
  ];

  const categories = [
    { id: "all", name: "All Projects", count: projects.length },
    {
      id: "ai",
      name: "AI/ML Projects",
      count: projects.filter((p) => p.category === "ai").length,
    },
    {
      id: "voice",
      name: "Voice",
      count: projects.filter((p) => p.category === "voice").length,
    },
    {
      id: "chatbot",
      name: "Chatbots",
      count: projects.filter((p) => p.category === "chatbot").length,
    },
  ];

  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((project) => project.category === filter);

  return (
    <div className={styles.projectsContainer}>
      <Navbar />

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Our Products</h1>
          <p className={styles.heroSubtitle}>
            Explore our portfolio of AI-powered solutions and innovative
            implementations. From voice analytics to intelligent chatbots, see
            how we transform ideas into reality.
          </p>
        </div>
        {/* Active Animated Bot Icon */}
        <div className={styles.activeBotIcon}>
          <div className={styles.botMain}>
            {/* Antenna */}
            <div className={styles.botAntenna}></div>

            {/* Head */}
            <div className={styles.botHead}>
              {/* Pulsing screen */}
              <div className={styles.botScreen}>
                <div className={styles.screenLine}></div>
                <div className={styles.screenLine}></div>
                <div className={styles.screenLine}></div>
              </div>

              {/* Animated eyes */}
              <div className={styles.botEyes}>
                <div className={styles.eye}>
                  <div className={styles.eyeDot}></div>
                </div>
                <div className={styles.eye}>
                  <div className={styles.eyeDot}></div>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className={styles.botBody}>
              {/* Status lights */}
              <div className={styles.statusLights}>
                <div
                  className={`${styles.statusLight} ${styles.activeLight}`}
                ></div>
                <div
                  className={`${styles.statusLight} ${styles.pulseLight}`}
                ></div>
                <div
                  className={`${styles.statusLight} ${styles.activeLight}`}
                ></div>
              </div>

              {/* Signal waves */}
              <div className={styles.signalWave}></div>
              <div className={styles.signalWave}></div>
            </div>

            {/* Base with moving parts */}
            <div className={styles.botBase}>
              <div className={styles.wheel}></div>
              <div className={styles.wheel}></div>
            </div>
          </div>
        </div>
      </section>
   
      {/* Filter Section */}
      <section className={styles.filterSection}>

        <div className={styles.filterContainer}>
          {categories.map((category) => (
            <button
              key={category.id}
              className={`${styles.filterButton} ${filter === category.id ? styles.activeFilter : ""}`}
              onClick={() => setFilter(category.id)}
            >
              {category.name}
              <span className={styles.filterCount}>{category.count}</span>
            </button>
          ))}
        </div>
      </section>

      {/* Projects Grid */}
      <section className={styles.projectsGridSection}>
        <div className={styles.projectsGrid}>
          {filteredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              className={styles.projectCard}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className={styles.projectImageContainer}>
                <img
                  src={project.image}
                  alt={project.title}
                  className={styles.projectImage}
                />
                <div
                  className={`${styles.statusBadge} ${styles[project.status]}`}
                >
                  {project.status.replace("-", " ")}
                </div>
              </div>

              <div className={styles.projectContent}>
                <div className={styles.projectMeta}>
                  <span className={styles.projectDate}>
                    {new Date(project.date).toLocaleDateString("en-US", {
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                  <span
                    className={`${styles.projectCategory} ${styles[project.category]}`}
                  >
                    {project.category.toUpperCase()}
                  </span>
                </div>

                <h3 className={styles.projectTitle}>{project.title}</h3>
                <p className={styles.projectDescription}>
                  {project.description}
                </p>

                <div className={styles.techStack}>
                  {project.tech.map((tech, idx) => (
                    <span key={idx} className={styles.techTag}>
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* < DemoDashboard /> */}

      {/* CTA Section */}
      <section className={styles.ctaSection}>
        <div className={styles.ctaContainer}>
          <h2 className={styles.ctaTitle}>Have a Project in Mind?</h2>
          <p className={styles.ctaText}>
            Let's discuss how we can bring your AI vision to life with our
            expertise and cutting-edge technology.
          </p>
          <div className={styles.ctaButtons}>
            <button
              className={styles.secondaryCta}
              onClick={() => (window.location.href = "/contactus")}
            >
              Schedule a Demo
            </button>
          </div>
        </div>
      </section>

      {/* Divider Line */}
      <div className={styles.divider}></div>

      {/* CCAI Feature Card */}
      <div className={styles.ccaiCard}>
        <div className={styles.cardAccent}></div>

        <div className={styles.cardContent}>
          <div className={styles.cardHeader}>
            <div className={styles.cardIcon}>🤖</div>
            <div>
              <span className={styles.cardLabel}>FLAGSHIP AI</span>
              <h3 className={styles.cardTitle}>CallCentry</h3>
            </div>
          </div>

          <p className={styles.cardDescription}>
            Advanced Voice Outreach — Automating outbound engagement for the
            mortgage industry.
          </p>

          <div className={styles.featurePills}>
            <span className={styles.pill}>CRM Integration</span>
            <span className={styles.pill}>Smart Handoff</span>
            <span className={styles.pill}>Sentiment AI</span>
          </div>

          <button
            className={styles.cardButton}
            onClick={() => (window.location.href = "/callsentry")}
          >
            <span>Explore CallCentry</span>
            <span className={styles.buttonArrow}>→</span>
          </button>
        </div>
      </div>

      <ContactUs />
      <Footer />
    </div>
  );
};

export default Projects;
